export default {
  features: {
    sellToAlif: {
      desc:
        'ООО "Alif Moliya" покупает указанные в заявке товары по согласованной цене. Нажимая кнопку «Продать», вы передаете право собственности на товары, указанные в заявке, ООО "Alif Moliya"',
      button: 'Продать',
    },
  },
};
